import { NAVER_REDIRECT_URI, NAVER_REST_API_KEY } from '../../../../constants/url';

import naverImg from '../../../../images/common/btn_naver.svg';

const NaverLogin = () => {
  const handleNaverLogin = () => {
    // state 는 CSRF 방지용. 콜백에서 돌아온 값과 대조한다.
    const state = window.crypto.randomUUID();
    sessionStorage.setItem('naver_state', state);

    const redirectUri = encodeURIComponent(NAVER_REDIRECT_URI);
    window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_REST_API_KEY}&redirect_uri=${redirectUri}&state=${state}`;
  };

  return (
    <div className="naver-login-container">
      <button data-login="naver" title="네이버 아이디로 로그인하기" onClick={handleNaverLogin}>
        <img src={naverImg} alt="네이버 로그인" />
      </button>
    </div>
  );
};

export default NaverLogin;
